import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import {
  Box,
  IconButton
} from "@mui/material";
import { useEffect, useState } from "react";
import { LoaderComponent } from "./Loader";
import { Map } from "./maps";
import { SmallHeaderMenu } from "./smallHeaderMenu";

const containerStyle = {
  width: "90%",
  height: "80%",
};

export const FindMyDevice = ({ uid }) => {
  useEffect(() => {}, []);
  const [open, setOpen] = useState(false);

  const findMyDeviceCb = () => {
    console.log("The uid to find: ", uid);
    setOpen(true);
    setTimeout(() => {
      setOpen(false);
    }, 2000);
  };

  return (
    <>
      <Box
        maxWidth="xs"
        sx={{
          ...containerStyle,
          display: "flex",
          flexDirection: "column",
          padding: 0,
          margin: 0,
        }}
      >
        <SmallHeaderMenu>
          <IconButton
            aria-label="delete"
            size="large"
            sx={{
              width: "50px",
              height: "50px",
            }}
            onClick={findMyDeviceCb}
          >
            <TravelExploreIcon></TravelExploreIcon>
          </IconButton>
        </SmallHeaderMenu>
        <Map></Map>
      </Box>
      <LoaderComponent open={open} type="spinner"></LoaderComponent>
    </>
  );
};
